import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth-o3/shared/services/auth.service';
import { AuthSettingsService } from './auth-o3/shared/services/auth-settings.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
    private authSettingsService: AuthSettingsService
  ) {}

  async ngOnInit() {
    await AuthService.configure(this.httpClient, this.authSettingsService);
  }
}
